<template>
  <div class="typography-content">
    <div class="brand-hero">
      <h1 class="hero-title">DecisionVue</h1>
      <p class="hero-subtitle">Harsh Environment</p>
      <div class="accent-bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandHero",
};
</script>

<style scoped>
.typography-content {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.brand-hero {
  text-align: center;
  max-width: 500px;
}

.hero-title {
  font-size: 72px;
  font-weight: 800;
  margin: 0 0 20px 0;
  letter-spacing: -2px;
  line-height: 1;
  text-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  animation: slideInDown 0.8s ease-out;
  background: linear-gradient(135deg, #2dbdb6 0%, #45d5ce 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-subtitle {
  font-size: 32px;
  font-weight: 300;
  margin: 0 0 30px 0;
  color: #c8f0ed;
  letter-spacing: 1px;
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  animation: slideInUp 0.8s ease-out 0.2s both;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.accent-bar {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2dbdb6 0%, #45d5ce 100%);
  border-radius: 2px;
  margin: 0 auto;
  animation: expandWidth 1s ease-out 0.4s both;
  box-shadow: 0 0 20px rgba(45, 219, 182, 0.6);
}

@keyframes expandWidth {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 80px;
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 44px;
  }

  .hero-subtitle {
    font-size: 20px;
  }
}
</style>
